import "@src/globals";
import "material-design-icons/iconfont/material-icons.css";
import "typeface-open-sans";

import { MainContent, MasterLayout, MuiThemeProvider, RouterBrowserRouter, SnackbarProvider } from "@comet/admin";
import { StyledEngineProvider } from "@mui/material/styles";
import ErrorProvider from "@src/components/apollo/errorprovider/ErrorProvider";
import theme from "@src/theme";
import { IntlProvider } from "react-intl";
import { Redirect, Switch } from "react-router-dom";
import { createGlobalStyle, ThemeProvider as StyledComponentsThemeProvider } from "styled-components";

import comet_admin_messages_de from "../lang-compiled/comet-lang/de.json";
import comet_admin_messages_en from "../lang-compiled/comet-lang/en.json";
import reviermanager_admin_messages_de from "../lang-compiled/reviermanager-admin/de.json";
import reviermanager_admin_messages_en from "../lang-compiled/reviermanager-admin/en.json";
import { FilteredRoutes, MasterHeader, MasterMenu } from "./components";
import ApolloProvider from "./components/apollo/ApolloProvider";
import UserProvider from "./components/user/UserProvider";
import { urls } from "./domain/urls";
import { Sentry } from "./utils/Sentry";

function getMessages(locale: string) {
    const defaultMessages = {
        ...comet_admin_messages_de,
        ...reviermanager_admin_messages_de,
    };

    if (locale === "en") {
        return {
            ...comet_admin_messages_en,
            ...reviermanager_admin_messages_en,
        };
    }

    return defaultMessages;
}

const GlobalStyle = createGlobalStyle`
    body  {
        margin: 0;
    }
`;

export function App() {
    return (
        <StyledEngineProvider injectFirst>
            <IntlProvider locale="de" messages={getMessages("de")} defaultLocale="de">
                <MuiThemeProvider theme={theme}>
                    <StyledComponentsThemeProvider theme={theme}>
                        <RouterBrowserRouter>
                            <UserProvider>
                                <Sentry>
                                    <ErrorProvider>
                                        <ApolloProvider>
                                            <SnackbarProvider>
                                                <>
                                                    <GlobalStyle />
                                                    <MasterLayout headerComponent={MasterHeader} menuComponent={MasterMenu}>
                                                        <MainContent>
                                                            <Switch>
                                                                <Redirect to={urls.dashboard} exact={true} from="/" />
                                                                <FilteredRoutes />
                                                            </Switch>
                                                        </MainContent>
                                                    </MasterLayout>
                                                </>
                                            </SnackbarProvider>
                                        </ApolloProvider>
                                    </ErrorProvider>
                                </Sentry>
                            </UserProvider>
                        </RouterBrowserRouter>
                    </StyledComponentsThemeProvider>
                </MuiThemeProvider>
            </IntlProvider>
        </StyledEngineProvider>
    );
}

export default App;
